(ns quuppa.qsm.site.view
  (:require [clojure.string :as str]
            [komponentit.input :as input]
            [quuppa.qsm.api-docs.component :as api-docs]
            [quuppa.qsm.permissions :as permissions]
            [quuppa.qsm.permissions-access :as permissions-access]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reitit.frontend.easy :as rfe]
            [quuppa.components :as components :refer [info-button]]
            [quuppa.date-time.core :as date-time]
            [quuppa.utils :as utils]
            [quuppa.ui.breadcrumbs :as b]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.spinner :refer [spinner]]
            [quuppa.ui.button :refer [button]]
            [quuppa.peweb.peinfo :as peinfo]
            [quuppa.peweb.peinfo-logs :as peinfo-logs]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.api-keys.view :as api-keys]
            [quuppa.qsm.configuration.view :as configuration]
            [quuppa.qsm.deployment.view :as deployment]
            [quuppa.qsm.features :as features]
            [quuppa.qsm.not-found :as not-found]
            [quuppa.qsm.projects.events :as pe]
            [quuppa.qsm.projects.subs :as ps]
            [quuppa.qsm.qpes.view :as qpes]
            [quuppa.qsm.site.events :as se]
            [quuppa.qsm.site.subs :as ss]
            [quuppa.qsm.site-plan.events :as spe]
            [quuppa.qsm.site-plan.view :as site-plan]
            [quuppa.qsm.ui-state.events :as ui-state]
            [quuppa.qsm.ui-state.subs :as state-subs]
            [quuppa.qsm.subs :as qsm-subs]
            [quuppa.qsm.view :as qsm-view]))

(declare engine-status-circle)

(def tabs-data
    [{:id :site-plan
      :label "Site Plan"
      :route :site-plan}
     {:id :engine
      :label "Engine"
      ;:suffix-fn (fn [_site qpe] [engine-status-circle qpe {:class "ml-1" :size "small"}]) ;; display circle in tab?
      :route :site-engine}
     {:id :map
      :route :site-info-map
      :label "Map"}
     {:id :locators
      :route :site-info-locators
      :label "Locators"}
     {:id :tags
      :route :site-info-tags
      :label "Tags"}
     {:id :log
      :route :site-info-log
      :label "Outputs"}
     {:id :api-docs
      :label "API docs"
      :route :site-api-docs}
     {:id :api
      :label "API keys"
      :route :site-api}])

(def tabs-data-without-api-docs
  [{:id :site-plan
    :label "Site Plan"
    :route :site-plan}
   {:id :engine
    :label "Engine"
    ;:suffix-fn (fn [_site qpe] [engine-status-circle qpe {:class "ml-1" :size "small"}]) ;; display circle in tab?
    :route :site-engine}
   {:id :map
    :route :site-info-map
    :label "Map"}
   {:id :locators
    :route :site-info-locators
    :label "Locators"}
   {:id :tags
    :route :site-info-tags
    :label "Tags"}
   {:id :log
    :route :site-info-log
    :label "Outputs"}
   {:id :api
    :label "API keys"
    :route :site-api}])

(def site-controller
  {:parameters {:path [:site-id]}
   :start (fn [params]
            ;; FIXME: If site -> qpe mapping breaks, this doesn't work correctly.
            (rf/dispatch [::se/get-qpe-data (-> params :path :site-id)])
            ;; Close open add site form it open when opening site page
            (rf/dispatch [::se/cancel-site-form])
            (q/execute spe/active-site-plan-query {:site-id (-> params :path :site-id (uuid))}))
   :stop (fn [_]
           ;; Close edit site when navigation out from the site
           (rf/dispatch [::se/cancel-site-form]))
   :subscriptions (fn [match]
                    (when-let [site-id (some-> match :parameters :path :site-id (uuid))]
                      [[:qpe/position-events {:site-id site-id}]
                       [:qpe/event {:site-id site-id :event [:current-project/state]}]
                       [:qpe/event {:site-id site-id :event [:current-project/info]}]
                       [:qpe/event {:site-id site-id :event [:current-project/info-partial]}]
                       [:qpe/event {:site-id site-id :event [:qpe/controller-state]}]
                       [:qpe/event {:site-id site-id :event [:qpe/file-sync-running]}]
                       [:qpe/event {:site-id site-id :event [:qpe/running?]}]
                       [:qpe/event {:site-id site-id :event [:qpe/existing-projects]}]
                       [:qpe/event {:site-id site-id :event [:qpe/server-info]}]
                       [:qpe/event {:site-id site-id :event [:qpe/start-changing-project]}]
                       [:qpe/event {:site-id site-id :event [:qpe/end-changing-project]}]
                       [:site-plan/new-active {:site-id site-id}]
                       [:site-plan/upload     {:site-id site-id}]]))})

(def site-view-tabs-controller
  {:id       :site-view-tabs
   :identity (fn [{:keys [parameters template]}]
               (let [[_ tab-suffix] (re-find #"/:site-id/(.*)$" template)]
                 (str/join "/"
                           [(get-in parameters [:path :project-id])
                            (get-in parameters [:path :site-id])
                            tab-suffix])))
   :stop     (fn [_match]
               ;; close ':site' sidebar whenever we leave a tab
               (rf/dispatch [::ui-state/close-sidebar :site]))})

;; Locator are part of the project
(def locators-controller
  {:id :qpe-locators
   :parameters {:path [:site-id]}
   :subscriptions nil})

(def tag-controller
  {:id :qpe-tags
   :parameters {:path [:site-id]}
   :start (fn [params]
            (rf/dispatch [:init/req-tags {:site-id (-> params :path :site-id)}]))
   :subscriptions (fn [match]
                    (when-let [site-id (some-> match :parameters :path :site-id (uuid))]
                      [[:qpe/event {:site-id site-id :event [:tag/removed]}]
                       [:qpe/event {:site-id site-id :event [:tag/added]}]
                       [:qpe/event {:site-id site-id :event [:tags/locations-changed]}]]))})
(def logs-controller
  {:parameters {:path [:site-id :log-type]}
   :start (fn [params]
            (let [log-type (or (:log-type (:path params))
                               :system)
                  ;; On QPE-next, path params don't have qpe-identity,
                  ;; but some of the event handlers don't need it either.
                  site-id (-> params :path :site-id)]
              (case log-type
                ;; :system -> req-logfile-list is triggered from view component with a hook -
                ;; it requires qpe-identity which isn't available here.
                :system (rf/dispatch [:qpe/req-current-log-subscribe {:site-id site-id}])
                :output-data (rf/dispatch [:qpe/req-output-data-files-metadata {:site-id site-id}])
                :binary-logs (rf/dispatch [:qpe/req-binarylog-files-metadata {:site-id site-id}])
                :data-player (rf/dispatch [:qpe/req-data-player-files-metadata {:site-id site-id}])
                :locators (rf/dispatch [:qpe/req-list-pe-logs {:site-id site-id} :locator])
                :tags (rf/dispatch [:qpe/req-list-pe-logs {:site-id site-id} :tag]))))
   :stop (fn [params]
           (let [log-type (or (:log-type (:path params))
                              :system)
                 site-id (-> params :path :site-id)]
             (case log-type
               :system ;; (do (rf/dispatch [:qpe/logfile-reset site-id]))
               (rf/dispatch [:qpe/req-current-log-unsubscribe {:site-id site-id}])
               :output-data nil ;; (rf/dispatch [:qpe/remove-output-data-files-metadata site-id])
               :binary-logs nil ;; (rf/dispatch [:qpe/remove-binarylog-files-metadata site-id])
               :data-player nil ;; (rf/dispatch [:qpe/remove-data-player-files-metadata site-id])
               :locators nil ;; (rf/dispatch [:qpe/remove-pe-logs site-id :locator])
               :tags nil)))}) ;; (rf/dispatch [:qpe/remove-pe-logs site-id :tag])


(defn site-form [{site-id :id,
                  :keys [on-submit on-cancel on-field-change error data]}]
  (let [{site-name :name, :keys [project-id]} data
        duplicate-site-name? @(rf/subscribe [::ss/duplicate-site-name project-id site-id site-name])
        disabled (or (utils/empty-string? site-name)
                     duplicate-site-name?)]

    [layout/sidebar-content
     [:form
      {:on-submit (fn [e]
                    (.preventDefault e)
                    (on-submit))}
      (when error
        [components/error-alert (:data error)])

      [:div.form-group
       [:label "Name"]
       [input/text
        {:class ["form-control" (when duplicate-site-name?
                                  "is-invalid")]
         :on-change #(on-field-change :name %)
         :value site-name}]
       (when duplicate-site-name?
         [:label.text-danger "The site '" site-name "' already exists within the selected project."])]

      [:div.form-group
       [:label "Project"]
       [input/select
        {:class "form-select"
         :on-change #(on-field-change :project-id %)
         :value (str project-id)
         :value-fn #(uuid %)
         :options (for [project @(q/subscribe pe/projects-query {} [:result])]
                    {:value (:id project)
                     :text (:name project)})}]]

      [:div.d-flex.flex-row.mx-n2.justify-content-end
       [:button.btn.btn-outline-light.border-gray-300.text-dark.mx-2.px-4
        {:on-click on-cancel
         :type "button"}
        "Cancel"]

       [:button.btn.btn-primary.mx-2.px-4
        {:type "submit"
         :disabled disabled}
        "Save"]]]]))

(defn edit-site-sidebar [{:keys [error data] :as form} site]
  [layout/sidebar
   [layout/sidebar-header
    {:title "Edit site"
     :on-close #(rf/dispatch [::se/cancel-site-form])}]

   [site-form
    {:id (:id form)
     :on-submit #(rf/dispatch [::se/save-site site])
     :on-cancel #(rf/dispatch [::se/cancel-site-form])
     :on-field-change #(rf/dispatch [::se/site-form-set-value %1 %2])
     :error error
     :data data}]])

(defn choose-qpe [_site owner-or-admin?]
  (let [available-sort-key (r/atom :name)
        available-sort-order-asc (r/atom true)]
    (fn [site]
      (let [sorted-available-qpes @(rf/subscribe [::qpes/sorted-available-managed-qpes @available-sort-key @available-sort-order-asc])]
        [:<>
         [:p.lead.text-muted.fw-medium "No engine connected to the site"]
         (when owner-or-admin?
           [:<>
            [:h5 "Available engines"]
            [:table.table.table-hover.table-bordered.table-striped
             [tables/thead
              {:columns qpes/managed-qpes-columns
               :sort-key @available-sort-key
               :sort-order-asc @available-sort-order-asc
               :toggle-sort-order (fn [] (swap! available-sort-order-asc not))
               :set-sort-key (fn [k]
                               (reset! available-sort-order-asc true)
                               (reset! available-sort-key k))}]
             [:tbody
              (for [qpe sorted-available-qpes]
                ^{:key (:id qpe)}
                [qpes/qpe-row qpe
                 {:manage? false
                  :action [button
                           {:variant "primary"
                            :on-click #(rf/dispatch [::se/set-qpe-site (:identity qpe) (:id site)])}
                           "Select"]}])]]])]))))

(defn run-mode
  [controller-state]
  (let [[title sub-title] (peinfo/run-mode-titles controller-state)]
    [:div.d-flex.flex-column
     [:h4.text-primary-900.fst-italic title]
     [:div.text-gray-500 sub-title]]))

(defn engine-mode-box [qpe owner-or-admin?]
  (let [controller-state @(rf/subscribe [:qpe/controller-state (:identity qpe)])
        simulation? (or (= :WaitingForQSP (:pe-run-mode controller-state))
                        (= :InvalidQSPVersion (:pe-run-mode controller-state))
                        (and (:simulator-mode? controller-state)
                             (= :Tracking (:pe-run-mode controller-state))))
        version (if (:pe-version controller-state)
                  (:pe-version controller-state)
                  (:version qpe))
        version-double (.toFixed (js/parseFloat (subs version 0 3)) 1)
        show-deployment-mode? (< version-double 9.1)]
    [:div.d-flex.flex-row.mb-3
     [:div.bg-gray-30.p-3.col-4.flex-shrink-1.border.border-gray-600.border-end-0.rounded-start
      [:h5.m-0.text-gray-900 "Mode"]]
     [:div.bg-gray-30.p-3.col-8.flex-shrink-1.border.border-gray-600.rounded-end.d-flex.flex-row
      [run-mode controller-state]
      [:div.flex-grow-1]
      ;; when QPE is offline, there is no data about controller-state etc
      (when (and (:pe-run-mode controller-state)
                 owner-or-admin?)
        [:div.d-flex.align-items-center.flex-shrink-0
         [button
          {:variant  "danger"
           :outline  (= :Stopped (:pe-run-mode controller-state))
           :class    "mr-2"
           ;:class "text-gray-700 border-gray-300 mr-2"
           :disabled (= :Stopped (:pe-run-mode controller-state))
           :on-click #(rf/dispatch [:qpe/run (:identity qpe) {:mode :stop}])}
          "Stop"]
         [dropdown/dropdown
          {:align "end"}
          [dropdown/toggle
           " Start in "
           [:div.caret-down]]
          [dropdown/menu
           [dropdown/item
            {:on-click #(rf/dispatch [:qpe/run (:identity qpe) {:mode :normal}])
             :disabled (and (= :Tracking (:pe-run-mode controller-state))
                            (not (:binary-log-mode? controller-state))
                            (not (:simulator-mode? controller-state)))}
            "Tracking mode"]
           (when show-deployment-mode?
             [dropdown/item
              {:on-click #(rf/dispatch [:qpe/run (:identity qpe) {:mode :deployment}])
               :disabled (= :Deployment (:pe-run-mode controller-state))}
              "Deployment mode"])
           [dropdown/item
            {:on-click #(rf/dispatch [:qpe/run (:identity qpe) {:mode :simulation}])
             :disabled simulation?}
            "Simulation mode"]
           [dropdown/item
            {:on-click #(rf/dispatch [:qpe/run (:identity qpe) {:mode :binary-log}])
             :disabled (and (:binary-log-mode? controller-state)
                            (= :Tracking (:pe-run-mode controller-state)))}
            "Binary log mode"]]]])]]))

(defn engine-details [qpe opts]
  (let [controller-state @(rf/subscribe [:qpe/controller-state (:identity qpe)])
        position-events @(rf/subscribe [:qpe/position-events (:identity qpe)])]
    [:table.table.table-sm.table-striped.table-bordered.w-100.peinfo-table
     [:tbody
      [:tr.table-header-row
       [:td
        {:col-span "2"}
        [:h4.my-1 "Hardware"]]]
      [:tr
       ;; Just one column has the width set, but that is enough. Just note that if you remove this row,
       ;; width should be set on some other row.
       [:th.w-25 {:scope "row"} "Platform Status:"
        [info-button
         [:span "Memory, Disk Space, and CPU status of the Platform."
          [:p "Configured memory is the value that was configured to JVM "]
          [:p "with eg. -Xmx2048m flag. Allocated is amount of memory "]
          [:p "allocated by JVM. Used is memory currently in use by JVM "]
          [:p "and free is memory that is available for JVM to use."]]]]
       [:td.no-icon
        [peinfo/platform-status (:platform-status controller-state)]]]
      [:tr
       [:th {:scope "row"} "Platform Data Rates:"
        [info-button
         [:span "Network Data Rates of the Platform."
          [:p " UDP RX is the Data Rate coming from the locators to the QPE. "]
          [:p "UDP TX is the Data Rate going out of the QPE. "]
          [:p "Consist mainly from active UPD streaming."]]]]
       [:td.no-icon
        [:div
         [:div (:platform-data-rates controller-state)]
         (when position-events
           [:div (str
                   "Received position events: "
                   (-> position-events :event-reception-rate)
                   "/s")])]]]
      [:tr
       [:th {:scope "row"} "QPE Loss Rate:"
        [info-button "Percentage of packets from Locators that the system didn't have time to process.
                     First value instant, average in parentheses."]]
       [:td.no-icon
        [peinfo/qpe-loss-rate controller-state]]]
      [:tr
       [:th {:scope "row"} "Network Loss Rate:"
        [info-button "Percentage of packets that were lost between Locators and QPE.
                     First value instant, average in parentheses."]]
       [:td.no-icon
        [peinfo/network-loss-rate controller-state]]]]

     [peinfo/peinfo-outputs opts]]))

(defn engine-status-circle [{:keys [status]} opts]
  (let [connection-established? (= "online" status)]
    [:span.qi-circle
     {:title (if connection-established?
               "Online"
               "Offline")
      :class [(:class opts)
              (:size opts)
              (:align opts)
              (if connection-established?
                "text-success"
                "text-danger")]
      :style (:style opts)}]))

(defn engine-header [qpe {:keys [select-peinfo-tab]}]
  (let [route-name @(rf/subscribe [:nav/route-name])
        offline? (= "offline" (:status qpe))]
    [:<>
     [:div.d-flex.flex-row.align-items-center.mb-3
      [:div.flex-grow-1
       [:div.d-flex.align-items-center
        [engine-status-circle qpe {:class "pl-2 mr-3"
                                   :style {:font-size "1rem"}}]
        [:div.h2.m-0
         (or (:name qpe)
             (:location qpe))]]

       [:div.text-gray-500
        ;; pl-4 doesn't match the circle width, so we need custom width here.
        {:style {:padding-left "2rem"}}
        (:version qpe)]]

      [:div.btn-group
       [:a.btn.btn-outline-light
        {:href  (select-peinfo-tab {:route :site-engine})
         :class (if (= :site-engine route-name)
                  "border-primary text-primary"
                  "border-gray-300 text-gray-500")}
        "System"]
       [:a.btn.ml-0.btn-outline-light
        {:href  (select-peinfo-tab {:route :site-engine-configuration})
         :class (if (= :site-engine-configuration route-name)
                  "border-primary text-primary"
                  "border-gray-300 text-gray-500")}
        "Configuration"]]]
     (when offline?
       [:div.alert.alert-danger.text-center "Engine is offline"])]))

(defn site-engine [site qpe {:keys [qpe-subscribe] :as opts} owner-or-admin?]
  [layout/section
   [layout/view-content
    {:sidebar-open @(qpe-subscribe [:qpe/data :ui :sidebar :type])}
    (if qpe
      [:<>
       [engine-header qpe opts]
       [engine-mode-box qpe owner-or-admin?]
       [engine-details qpe opts]]
      [choose-qpe site owner-or-admin?])]
   [peinfo/peinfo-sidebar opts]])

(defn engine-tab [site qpe opts owner-or-admin?]
  (case @(rf/subscribe [:nav/route-name])
    :site-engine-configuration
    [:f> configuration/configuration-view
     {:qpe qpe
      :opts opts
      :header [engine-header qpe opts]
      :owner-or-admin? owner-or-admin?}]

    :site-engine
    [site-engine site qpe opts owner-or-admin?]))

(defn engine-state
  "Shows small engine status alert box in Site plan card"
  [site-plan engine-status controller-state {:keys [qpe-dispatch select-peinfo-tab] :as _opts}]
  (let [engine-project-name        (:project-name controller-state)
        engine-connected?          (= "online" engine-status)
        engine-plan-key            (:license-key controller-state)
        running-correct-site-plan? (= (:key site-plan) engine-plan-key)]
    [:div
     [:div.alert.alert-light.px-0.m-0
      ;; TODO: this will be removed when 1:1 relationship of site <-> engine is removed
      ;; now here just to give hint about what is the status in engine, if there is something wrong with the
      ;; project data/key.
      [:h5
       {:class (if engine-connected?
                 "text-success"
                 "text-warning")}
       [:a.alert-link
        {:href (select-peinfo-tab {:route :site-engine})}
        "Engine"]
       " " (if engine-connected? "online" "offline")]
      (if-not engine-connected?
        [:span "Engine not connected."]
        (let [[title _subtitle] (peinfo/run-mode-titles controller-state)]
          [:<>
           [:p.text-success.fst-italic title (when (seq engine-project-name) (str " - " engine-project-name))]
           (when-not running-correct-site-plan?
             [:div.alert.alert-danger.d-flex.flex-column.align-items-center.mb-0
              (if (nil? engine-plan-key)
                [:p.fst-italic "No project"]
                [:<>
                 [:span "Engine is running different Site plan key:"]
                 [:code.my-2 engine-plan-key]])
              (when (:key site-plan)
                [button
                 {:on-click #(qpe-dispatch [::spe/set-engine-key (:key site-plan) (:password site-plan)])}
                 "Switch engine to current Site plan"])])]))]]))

(defn sync-information [engine-status controller-state {:keys [qpe-subscribe qpe-dispatch]}]
  [:div.d-flex.flex-row.align-items-center
   [:div.flex-grow-1
    [peinfo/date-time-field
     {:title "Last sync"}
     (:last-sync-status controller-state)]]
   (when @(qpe-subscribe [:controller-ui/state-flags :req-file-sync])
     [spinner])
   (when (= "online" engine-status)
     [:button.btn.btn-outline-primary.border-0.px-2
      {:title    "Perform file-sync"
       :on-click #(qpe-dispatch [:qpe/force-file-sync])
       :disabled @(qpe-subscribe [:controller-ui/file-sync-control-disabled?])}
      "Update"])])

(defn selected-site-plan [{initial :initial-load site-plan :result :as site-plan-query} controller-state owner-or-admin?]
  (if (and (not initial)
           (not site-plan))
    ;; loaded, but nothing available
    (when owner-or-admin?
      [:div.d-flex.flex-row.justify-content-center.my-2
       [button
        {:on-click (fn [_]
                     (rf/dispatch [::ui-state/set-sidebar-type :site :select-site-plan]))
         :variant "primary"
         :title "Upload new Site plan"
         :large true}
        "Upload"]])
    ;; TODO: better place for site plan metadata, now we pick 'name' only if engine reports it, otherwise we don't know it
    [site-plan/selected-plan
     (assoc site-plan :name (:project-name controller-state))
     {:loading? (:loading site-plan-query)}]))

(def card-div :div.card.py-2.px-3)

(defn site-plan-card [{:keys [site site-plan-query controller-state opts owner-or-admin?]}]
  (let [site-plan (:result site-plan-query)
        {engine-status :status} @(rf/subscribe [::ss/site-qpe (:id site)])
        some-loading?       (:loading site-plan-query)]
    [card-div
     {:class "bg-gray-30"}
     [:div.d-flex.align-items-center
      [:h3.py-2.my-0 "Site Plan"]
      [:div.d-flex.flex-grow-1.align-items-center
       {:aria-live  "polite"
        :aria-busy  some-loading?
        :aria-label "Site plan loading"
        :role       "status"}
       (when some-loading?
         [spinner])]
      (when owner-or-admin?
        [dropdown/dropdown
         {:align "end"
          :title "Site actions"
          :hidden (when-not site-plan true)}
         [dropdown/menu-icon-toggle]
         [dropdown/menu
          [dropdown/item
           {:on-click #(rf/dispatch [::ui-state/set-sidebar-type :site :select-site-plan])}
           "Change Site plan"]]])]

     [selected-site-plan site-plan-query controller-state owner-or-admin?]
     [engine-state site-plan engine-status controller-state opts]
     [sync-information engine-status controller-state opts]]))

(defn license-card [project-license]
  [card-div
   [:h3.py-2.mb-1 "License"]
   (cond
     (nil? project-license)
     [:div.alert.alert-warning "No engines connected, license information unavailable."]

     (:id project-license)
     [:<>
      [:div
       (if (nil? (and (:expirationDate project-license)
                      (.isAfter (:expirationDate project-license)
                                (.plusWeeks (date-time/zoned-now) 1))))
         [:strong.text-success "OK"]
         [:strong.text-warning "NOT OK"])]
      [:div.d-flex.flex-row.align-items-center
       [:span.flex-grow-1
        (cond
          (nil? (:expirationDate project-license)) "-"
          (:isPerpetual project-license) "Perpetual license"
          :else
          ;; TODO: This is local date but is formatting call OK?
          [:span "Valid until " (date-time/format-local-date (:expirationDate project-license))])]
       [button
        {:variant  "dark"
         :outline  true
         :end-icon :chevron-right
         :on-click #(rf/dispatch [::ui-state/update :site update :sidebar (fn [sb]
                                                                            ;; "toggle"
                                                                            (when-not (= :license-details (:type sb))
                                                                              {:type :license-details}))])}
        "Details"]]]

     :else
     [:p "No license set / Engine not tracking."])])

(defn deployments [site-plan-key owner-or-admin?]
  [:div
   [:div.d-flex.flex-row.align-items-center.mb-3.px-3
    [:h3.my-0 "Deployments"]
    ;; sc-27482, creating new deployment doesn't require QPE to be online anymore
    [button
     {:outline true
      :attr {:title "New deployment"}
      :disabled (and (empty? site-plan-key)
                     (not owner-or-admin?))
      :class "ml-3 rounded-circle p-1 lh-1"
      :on-click #(rf/dispatch [::ui-state/set-sidebar-type :site :new-deployment])}
     [icon :plus.icon-md {:title "New deployment"}]]]

   [:f> deployment/deployments-table site-plan-key owner-or-admin?]])

(defn site-plan [site {:keys [qpe-subscribe] :as opts} owner-or-admin?]
  (let [controller-state @(qpe-subscribe [:qpe/controller-state])
        license @(qpe-subscribe [:current-project/license])
        sidebar @(rf/subscribe [::state-subs/ui-state :site :sidebar])
        {current :result :as site-plan-query} @(q/subscribe spe/active-site-plan-query {:site-id (:id site)})]
    [layout/section
     [layout/view-content
      {:sidebar-open (some? sidebar)}

      [:div.mb-3.d-flex.flex-row.row.g-3
       [:div.col-12.col-md-8 [site-plan-card
                              {:site site
                               :site-plan-query site-plan-query
                               :controller-state controller-state
                               :opts opts
                               :owner-or-admin? owner-or-admin?}]]
       [:div.col-12.col-md-4 [license-card license]]]

      ;; FIXME correct key!
      (when owner-or-admin?
        [deployments (:key current)])]

     (case (:type sidebar)
       ;; NOTE: passing close-fn is for legacy support with old 'qpe view' where same license-details component is used
       :license-details [peinfo/license-details license {:close-fn #(rf/dispatch [::ui-state/close-sidebar :site])}]
       :new-deployment [deployment/new-deployment-form (:key current)]
       :select-site-plan [:f> site-plan/site-plan-sidebar site current]
       nil)]))

(defn site-page []
  (let [{:keys [site-id project-id]} @(rf/subscribe [:nav/match :parameters :path])
        site @(rf/subscribe [::ss/site project-id site-id])
        project @(rf/subscribe [::ps/project project-id])
        owner-or-admin? (or (permissions/has-manage-permission?)
                            (permissions/has-manage-permission-to-resource? site))
        qpe @(rf/subscribe [::ss/site-qpe (:id site)])

        qpe-identity (:identity qpe)
        qpe-subscribe (fn [[event-id & args]] (rf/subscribe (into [event-id qpe-identity] args)))
        qpe-dispatch (fn [[event-id & args]] (rf/dispatch (into [event-id qpe-identity] args)))
        selected-peinfo-tab (or @(rf/subscribe [:nav/match :data :qpe-info-tab])
                                @(rf/subscribe [:nav/route-name]))
        select-peinfo-tab (fn [{:keys [route]}]
                            (rfe/href route {:project-id project-id
                                             :site-id site-id}))
        select-log-tab (fn [{:keys [log-type]}]
                         (rfe/href :site-info-log-type {:project-id project-id
                                                        :site-id site-id
                                                        :log-type log-type}))
        current-user @(rf/subscribe [::qsm-subs/user])
        current-user-role (permissions-access/get-user-role current-user)
        tabs-data (if (= current-user-role "member") tabs-data-without-api-docs tabs-data)
        opts {:qpe-subscribe qpe-subscribe
              :qpe-dispatch qpe-dispatch
              :qpe-identity qpe-identity
              :selected-peinfo-tab selected-peinfo-tab
              :select-peinfo-tab select-peinfo-tab
              :select-log-tab select-log-tab
              :parameters @(rf/subscribe [:nav/match :parameters])
              :features (features/get-features)}]
    [layout/section
     ;; Navbar-content is rendered into app navbar through React Portal
     [qsm-view/navbar-content
      [b/breadcrumbs
       {:class "my-0 pl-2"}
       [b/breadcrumb-item [:a
                           {:href (rfe/href :projects)}
                           "Projects"]]
       [b/breadcrumb-item [:a
                           {:href (rfe/href :project {:project-id project-id})}
                           (:name project)]]
       [b/breadcrumb-current (:name site)]]]

     (if-not site
       [not-found/not-found-view {:text "No Site found"}]
       ;; TODO: Would be best if didn't use view-content here,
       ;; this is used inside the tab views. As a workaround, container class is disabled.
       [layout/view-content
        {:container        false
         :sidebar-open     @(rf/subscribe [::ss/site-form])
         :padded?          false
         :scroll-container false}

        ;; pad the header + navbar
        [:div.px-4.pt-4.flex-shrink-0
         [layout/section-header
          {:title (:name site)
           :title-menu (when owner-or-admin?
                         [dropdown/dropdown
                          [dropdown/menu-icon-toggle
                           ;; display: flex so that padding works for square shape
                           {:class "d-flex text-gray-500 icon-md"}]
                          [dropdown/menu
                           [dropdown/item
                            {:on-click #(rf/dispatch [::se/init-edit-site-form site])}
                            [:div.d-flex.align-items-center
                             [icon :pencil-fill.mr-2.text-gray-700] "Edit site details"]]
                           [dropdown/item
                            {:on-click #(rf/dispatch [::se/delete-site site-id (:name site)])
                             :style {:pointer-events "all"}}
                            [:div.d-flex.align-items-center
                             [icon :trash-fill.mr-2.text-danger] "Delete site"]]
                           [dropdown/item
                            {:disabled false
                             :href (rfe/href :users nil {:view "site"
                                                         :project (str project-id)
                                                         :site (str site-id)})
                             :on-click (fn [])
                             :style {:pointer-events "all"}}
                            [:div.d-flex.align-items-center
                             [icon :people.mr-2.text-gray-700] "Site user management"]]]])}]
         ;; negative margin should match view-content container padding (p-4)
         ;; so that the nav-tabs border is full width
         [:ul.nav.nav-tabs.flex-shrink-0.mt-2.mx-n4.px-4
          (for [tab tabs-data
                :let [selected? (= selected-peinfo-tab (:id tab))
                      suffix-fn (get tab :suffix-fn (constantly nil))]]
            [:li.nav-item
             {:key (:id tab)}
             [:a.nav-link
              {:href         (select-peinfo-tab tab)
               :class        (when selected?
                               "active")
               :aria-current (when selected? "true")}
              (:label tab)
              (suffix-fn site qpe)]])]]

        [components/error-boundary
         (case selected-peinfo-tab
           :site-plan [site-plan site opts owner-or-admin?]
           :engine [engine-tab site qpe opts owner-or-admin?]
           :api [:f> api-keys/api-keys-view opts owner-or-admin?]
           :api-docs [api-docs/lazy-api-docs opts]
           :log [peinfo-logs/qpe-details-log opts]
           [peinfo/peinfo-tab opts])]])

     ;; FIXME: The modals should be on the tabs?

     (when-let [form @(rf/subscribe [::ss/site-form])]
       [edit-site-sidebar form site])]))
